import type { StateCreator } from 'zustand'

import type { OnboardingActionsSlice, OnboardingStep, OnboardingStore } from './onboarding.type'

type OnboardingSet = Parameters<StateCreator<OnboardingStore, [['zustand/immer', never]], [], OnboardingStore>>[0]

export const createOnboardingActions = (set: OnboardingSet): OnboardingActionsSlice => ({
  startOnboarding: () =>
    set((state) => {
      state.isOnboarding = true
      state.currentStep = 'user'
      state.error = null
    }),
  completeOnboarding: () =>
    set((state) => {
      state.isOnboarding = false
      state.currentStep = 'complete'
      state.error = null
    }),
  setCurrentStep: (step: OnboardingStep | null) =>
    set((state) => {
      state.currentStep = step
    }),
  setError: (error: string | null) =>
    set((state) => {
      state.error = error
    }),
  reset: () =>
    set((state) => {
      state.isOnboarding = false
      state.currentStep = null
      state.error = null
    }),
})
